import Bus from 'util/bus'

export function navigateTo(url) {
  Bus.emit('navigateTo', url)
}

export function redirectTo(url) {
  Bus.emit('redirectTo', url)
}

export function switchTab(url) {
  Bus.emit('switchTab', url)
}

export function navigateBack(url = '/') {
  Bus.emit('navigateBack', url)
}
